import { FieldArray, FormikErrors, FormikHandlers } from "formik";
import moment from "moment";
import { FC } from "react";
import { Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { TextFieldCustom } from "../../../../category-personnel/components/text-field-custom/TextFieldCustom";
import AutocompleteObjectV2 from '../../../../component/AutocompleteObjectV2';
import { searchHospitalCouncil } from "../../../benh-vien/services";
import { initScienceCouncilMember, TAddScienceCouncil, TScienceCouncilDetails, TScienceCouncilMember } from "../../models/ScienceCouncilManagerModels";

type Iprops = {
  values: TAddScienceCouncil;
  errors: FormikErrors<TAddScienceCouncil>;
  handleChange: FormikHandlers['handleChange'];
  handleBlur:FormikHandlers['handleBlur'];
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  isView?: boolean;
  details?: TScienceCouncilDetails & { allowUpdateMembers?: boolean };
};

const Step2: FC<Iprops> = (props) => {
  const { values, errors, handleChange,handleBlur, setFieldValue, isView, details } = props;

  return (
    <div className="w-100">
      <Row className="py-2">
        <Col xs={12}>
          <div className="flex align-items-center">
            <div className="label min-w-100px fw-bold">Số thành viên</div>
            <div className="flex-1 spaces pe-3">
              <TextFieldCustom
                type="number"
                title=""
                name="numMembers"
                values={values.numMembers}
                errors={errors.numMembers}
                onBlur={(e: React.FocusEvent<any>) => {
                  let quantity = Number(e.target.value);
                            const currentLength = values.members.length;
                            if (quantity > currentLength) {
                              let newMemberList: TScienceCouncilMember[] = Array.from(
                                { length: quantity -currentLength },
                                () => (initScienceCouncilMember)
                              );
                              setFieldValue("members", [...values.members, ...newMemberList]);
                            }
                            else if(quantity< currentLength){
                              setFieldValue("members", values.members.slice(0, quantity))
                            }
                 
                  handleBlur(e);
                }}
                handleChange={(e: React.ChangeEvent<any>) => {
                  let quantity = Number(e?.target?.value);
                  if (quantity > 5) {
                    toast.warning("Không được quá 5 thành viên");
                    return;
                  }
                  handleChange(e);
                }}
              />
            </div>
          </div>
        </Col>
      </Row>
      <Row className="py-2">
        <FieldArray
          name="members"
          render={() => (
            <Row>
              {(values?.members)?.map((item: TScienceCouncilMember, index: number) => (
                <Col xs={index === 0 ? 12 : 6}
                  className={`member flex py-3 border`}
                  key={index}
                >
                  <>
                    <div className="label min-w-100px fw-bold text-pri spaces  py-8">
                      {index === 0 && (
                        <div>Chủ tịch HĐ</div>
                      )}
                      {index === 1 && (
                        <div>Thư ký</div>
                      )}
                      {index === 2 && (
                        <div>Thành viên 1</div>
                      )}
                      {index === 3 && (
                        <div>Thành viên 2</div>
                      )}
                      {index === 4 && (
                        <div>Thành viên 3</div>
                      )}
                    </div>
                    <div className="flex-1">
                      {isView ? (
                        <TextFieldCustom
                          type="text"
                          title=""
                          name={`members.${index}.name`}
                          disabled={isView}
                          values={values?.members?.[index]?.name}
                          errors={""}
                          handleChange={handleChange}
                        />
                      ): (
                        <AutocompleteObjectV2
                          options={[]}
                          menuPlacement="bottom"
                          name={`member${index + 1}`}
                          onChange={(option: any) =>  { setFieldValue(`members.${index}`, 
                            {
                              ...option,
                              gender: option?.gender?.code,
                              duty: option?.viTriCongViecText,
                              department: option?.phongBanText,
                              position: option?.chucVuText,
                              email: option?.emailCaNhan,
                              username: option?.username,
                              isChairman: Boolean(index === 0),
                              isSecretary: Boolean(index === 1),
                            }
                          )}}
                          searchFunction={() => searchHospitalCouncil(values.year || details?.year || moment().year())}
                          value={values?.members?.[index]}
                          errors={errors?.members?.[index]}
                          searchObject={{}}
                          getOptionLabel={(e: any) => e?.name}
                          dependencies={[values.year || details?.year]}
                          isDisabled={details?.id ? !details?.allowUpdateMembers : false}
                        />
                      )}
                    </div>
                  </>
                </Col>
              ))}
            </Row>
          )}
        />
      </Row>
    </div>
  );
};

export { Step2 };

